export default {
  user: {
    country: {
    },
    profession: {
    },
    photo: {
    },
    organization: {
      country: {
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/models/user.js